import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LocationService, UserLocation } from '../../services/location.service';

@Component({
  selector: 'app-location-banner',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './location-banner.component.html',
  styleUrl: './location-banner.component.scss',
})
export class LocationBannerComponent implements OnInit, OnDestroy {
  private readonly isBrowser: boolean;
  private sub!: Subscription;

  location: UserLocation | null = null;
  isDetecting = false;
  detectError: string | null = null;

  readonly radiusOptions = [10, 25, 50, 100];

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    readonly locationService: LocationService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.sub = this.locationService.location$.subscribe((loc) => {
      this.location = loc;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  onRadiusChange(event: Event): void {
    const miles = parseInt((event.target as HTMLSelectElement).value, 10);
    this.locationService.setRadius(miles);
  }

  async detectLocation(): Promise<void> {
    this.isDetecting = true;
    this.detectError = null;
    const result = await this.locationService.detectFromBrowser();
    this.isDetecting = false;
    if (!result) {
      this.detectError = 'Unable to detect location. Please check your browser permissions or enter your city in the search above.';
    }
  }
}
